// extracted by mini-css-extract-plugin
export default {"pageWrap":"Nb-z","fullWidth":"Ob-z","heading":"Pb-z","fullBleed":"Qb-z","hidden":"Rb-z"};